var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3043 7.30475H0.695641C0.311445 7.30475 0 7.61619 0 8.00039C0 8.38458 0.311445 8.69603 0.695641 8.69603H15.3043C15.6885 8.69603 16 8.38458 16 8.00039C16 7.61619 15.6885 7.30475 15.3043 7.30475Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.695641 3.82622H15.3043C15.6885 3.82622 16 3.51477 16 3.13058C16 2.74638 15.6885 2.43494 15.3043 2.43494H0.695641C0.311445 2.43494 0 2.74638 0 3.13058C0 3.51477 0.311445 3.82622 0.695641 3.82622Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3043 12.174H0.695641C0.311445 12.174 0 12.4854 0 12.8696C0 13.2538 0.311445 13.5653 0.695641 13.5653H15.3043C15.6885 13.5653 16 13.2538 16 12.8696C16 12.4854 15.6885 12.174 15.3043 12.174Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.c5b70ed5bd0b0cfc285d0bab8afdb381.svg";
export { ForwardRef as ReactComponent };